import { render, staticRenderFns } from "./customer_documents.vue?vue&type=template&id=05d7e525&scoped=true&"
import script from "./customer_documents.vue?vue&type=script&lang=js&"
export * from "./customer_documents.vue?vue&type=script&lang=js&"
import style0 from "./customer_documents.vue?vue&type=style&index=0&id=05d7e525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7e525",
  null
  
)

export default component.exports